import { render, staticRenderFns } from "./ProductCP1.vue?vue&type=template&id=b4d86eb6&scoped=true&"
import script from "./ProductCP1.vue?vue&type=script&lang=js&"
export * from "./ProductCP1.vue?vue&type=script&lang=js&"
import style0 from "./ProductCP1.vue?vue&type=style&index=0&id=b4d86eb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d86eb6",
  null
  
)

export default component.exports